const progressGradient: object = {
  "blue-gray": {
    backgroud: "bg-gradient-to-tr from-blue-gray-600 to-blue-gray-400",
    color: "text-white",
  },
  gray: {
    backgroud: "bg-gradient-to-tr from-gray-600 to-gray-400",
    color: "text-white",
  },
  brown: {
    backgroud: "bg-gradient-to-tr from-brown-600 to-brown-400",
    color: "text-white",
  },
  "deep-orange": {
    backgroud: "bg-gradient-to-tr from-deep-orange-600 to-deep-orange-400",
    color: "text-white",
  },
  orange: {
    backgroud: "bg-gradient-to-tr from-orange-600 to-orange-400",
    color: "text-white",
  },
  amber: {
    backgroud: "bg-gradient-to-tr from-amber-600 to-amber-400",
    color: "text-black",
  },
  yellow: {
    backgroud: "bg-gradient-to-tr from-yellow-600 to-yellow-400",
    color: "text-black",
  },
  lime: {
    backgroud: "bg-gradient-to-tr from-lime-600 to-lime-400",
    color: "text-black",
  },
  "light-green": {
    backgroud: "bg-gradient-to-tr from-light-green-600 to-light-green-400",
    color: "text-white",
  },
  green: {
    backgroud: "bg-gradient-to-tr from-green-600 to-green-400",
    color: "text-white",
  },
  teal: {
    backgroud: "bg-gradient-to-tr from-teal-600 to-teal-400",
    color: "text-white",
  },
  cyan: {
    backgroud: "bg-gradient-to-tr from-cyan-600 to-cyan-400",
    color: "text-white",
  },
  "light-blue": {
    backgroud: "bg-gradient-to-tr from-light-blue-600 to-light-blue-400",
    color: "text-white",
  },
  blue: {
    backgroud: "bg-gradient-to-tr from-blue-600 to-blue-400",
    color: "text-white",
  },
  indigo: {
    backgroud: "bg-gradient-to-tr from-indigo-600 to-indigo-400",
    color: "text-white",
  },
  "deep-purple": {
    backgroud: "bg-gradient-to-tr from-deep-purple-600 to-deep-purple-400",
    color: "text-white",
  },
  purple: {
    backgroud: "bg-gradient-to-tr from-purple-600 to-purple-400",
    color: "text-white",
  },
  pink: {
    backgroud: "bg-gradient-to-tr from-pink-600 to-pink-400",
    color: "text-white",
  },
  red: {
    backgroud: "bg-gradient-to-tr from-red-600 to-red-400",
    color: "text-white",
  },
};

export default progressGradient;
